import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import ObjectItems from './ObjectItems';
import ABSUtils from '@abs/utils/ABSUtils';
import themesConfig from 'app/configs/themesConfig';
import { authModules } from 'app/auth';

const AllObjectItems = lazy(() => import('./allobjectitems/AllObjectItems'));
const SingleObjectItem = lazy(() => import('./singleobjectitem/SingleObjectItem'));

const ObjectItemsConfig = {
  settings: {
    layout: {},
		theme: {
			main: ABSUtils.IsDarkMode() ? themesConfig.timeliteDark : themesConfig.timelite,
			navbar: ABSUtils.IsDarkMode() ? themesConfig.timeliteDark : themesConfig.timelite,
		}
  },
  routes: [
    {
      path: '/tl/o/:objectType',
      element: <ObjectItems />,
      auth: authModules.tl_default,
      children: [
        {
          path: '',
          element: <AllObjectItems />,
        },
        {
          path: '/tl/o/:objectType/:projectID',
          element: <SingleObjectItem />,
        },
      ],
    },
  ]
};

export default ObjectItemsConfig;
